import {EnhancersForCementClassificationInputNames, MaterialType} from '@domain/materials'

import {ClassificationHeaderCells} from './ClassificationHeaderCells'

import {LONG_COLUMN_WIDTH} from '@settings/modules/common/consts'

const fields = [
  {key: EnhancersForCementClassificationInputNames.Category, minWidth: LONG_COLUMN_WIDTH},
  {key: EnhancersForCementClassificationInputNames.SubCategory, minWidth: LONG_COLUMN_WIDTH},
  {key: EnhancersForCementClassificationInputNames.Brand, minWidth: LONG_COLUMN_WIDTH},
  {key: EnhancersForCementClassificationInputNames.OtherBrand, minWidth: LONG_COLUMN_WIDTH}
]

export const EnhancersForCementClassificationHeader = () => {
  return (
    <ClassificationHeaderCells fields={fields} materialType={MaterialType.EnhancersForCement} />
  )
}
